/* eslint-disable max-len */
import React, { useRef } from "react"
import AnimatedModel from "../../../../../components/Animation/AnimatedModel"
import Loader from "../../../../../components/Loader"
import { useOnClickOutside } from "../../../../../CommonMethods/OutsideClick"

export default function ParentInvitePopup({
    parentInviteList,
    handleClose,
    handleSendInvite,
    fatherInviteLoading,
    motherInviteLoading
}) {
    const popupRef = useRef()

    useOnClickOutside(popupRef, () => {
        handleClose()
    })

    return (
        <AnimatedModel
            Children={
                <div
                    className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50"
                    style={{ display: "block" }}
                >
                    <div className="relative flex min-h-[calc(100%-1rem)] w-auto items-center justify-center p-4">
                        <div
                            ref={popupRef}
                            className="pointer-events-auto w-full max-w-[720px] rounded-md bg-white shadow-lg outline-none"
                        >
                            <div className="flex items-center justify-between border-b border-[#E4E7EC] px-5 py-3">
                                <p className="text-lg font-semibold text-[#031624]">Parent Invite</p>
                                <button onClick={handleClose} type="button">
                                    <img src="/images/modalClose.svg" alt="Close" />
                                </button>
                            </div>

                            <div className="px-5 py-4">
                                {parentInviteList.map((parent) => (
                                    <div
                                        key={parent.type}
                                        className="flex items-center justify-between gap-3 border border-[#E4E7EC] rounded-md px-4 py-3 mb-3"
                                    >
                                        <div className="w-[28%]">
                                            <p className="text-f7 font-semibold text-[#031624] break-words">{parent.name}</p>
                                        </div>
                                        <div className="w-[42%]">
                                            <p className="text-f7 font-normal text-[#031624] break-words">{parent.email}</p>
                                        </div>
                                        <div className="w-[30%] flex justify-end">
                                            <button
                                                type="button"
                                                className="actn-btn"
                                                disabled={parent.type === "father" ? fatherInviteLoading : motherInviteLoading}
                                                onClick={() => handleSendInvite(parent.type)}
                                            >
                                                {(parent.type === "father" ? fatherInviteLoading : motherInviteLoading)
                                                    ? <span><Loader /></span>
                                                    : parent.buttonLabel}
                                            </button>
                                        </div>
                                    </div>
                                ))}

                                <div className="flex justify-center pt-2">
                                    <button type="button" className="cancl-btn" onClick={handleClose}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    )
}
